<template lang="pug">
  div

    h3(class="headerSection") Pencegahan / Persyaratan Khusus
    small(class="pl-4 orange--text") *Silahkan isi semua daftar periksa berikut, Jika pilih Ya maka wajib disertakan deskripsi.

    v-row.mt-5
      v-col(cols="12" lg="6")
        p(
          class="pl-4"
          style="font-size:14px"
        ) Apakah perubahan perlu perubahan terhadap standar atau prosedur K3L?
      v-col(cols="6" lg="2")
        v-select(
          class="selectInput" 
          :items='checkOptions' 
          label="Pilih" 
          clearable 
          v-model="dataSubmitPerubahan.ipPerluPerubahan.selected"
          @change="handleChangeSelect(dataSubmitPerubahan.ipPerluPerubahan)"
        ) 
      v-col(cols="6" lg="3" class="mt-n6")
        v-text-field(
          label="Tuliskan" 
          v-model="dataSubmitPerubahan.ipPerluPerubahan.description" 
          :disabled="!dataSubmitPerubahan.ipPerluPerubahan.selected"
        )

    v-row.mt-n3
      v-col(cols="12" lg="6")
        p(
          class="pl-4"
          style="font-size:14px"
        ) Apakah perubahan mempengaruhi garansi atau perjanjian pemeliharaan?
      v-col(cols="6" lg="2")
        v-select(
          class="selectInput" 
          :items='checkOptions' 
          label="Pilih" 
          clearable 
          v-model="dataSubmitPerubahan.ipMempengaruhiGaransi.selected"
          @change="handleChangeSelect(dataSubmitPerubahan.ipMempengaruhiGaransi)"
        ) 
      v-col(cols="6" lg="3" class="mt-n6")
        v-text-field(
          label="Tuliskan" 
          v-model="dataSubmitPerubahan.ipMempengaruhiGaransi.description" :disabled="!dataSubmitPerubahan.ipMempengaruhiGaransi.selected"
        )

    v-row.mt-n3
      v-col(cols="12" lg="6")
        p(
          class="pl-4"
          style="font-size:14px"
        ) Apakah perubahan mempengaruhi spesifikasi pekerjaan pemeliharaan?
      v-col(cols="6" lg="2")
        v-select(
          class="selectInput" 
          :items='checkOptions' 
          label="Pilih" 
          clearable 
          v-model="dataSubmitPerubahan.ipMempengaruhiSpek.selected"
          @change="handleChangeSelect(dataSubmitPerubahan.ipMempengaruhiSpek)"
        ) 
      v-col(cols="6" lg="3" class="mt-n6")
        v-text-field(
          label="Tuliskan" 
          v-model="dataSubmitPerubahan.ipMempengaruhiSpek.description" :disabled="!dataSubmitPerubahan.ipMempengaruhiSpek.selected"
        )

    v-row.mt-n3
      v-col(cols="12" lg="6")
        p(
          class="pl-4"
          style="font-size:14px"
        ) Apakah perubahan memerlukan pemutakhiran gambar?
      v-col(cols="6" lg="2")
        v-select(
          class="selectInput" 
          :items='checkOptions' 
          label="Pilih" 
          clearable 
          v-model="dataSubmitPerubahan.ipPerluUpdate.selected"
          @change="handleChangeSelect(dataSubmitPerubahan.ipPerluUpdate)"
        ) 
      v-col(cols="6" lg="3" class="mt-n6")
        v-text-field(
          label="Tuliskan" 
          v-model="dataSubmitPerubahan.ipPerluUpdate.description" 
          :disabled="!dataSubmitPerubahan.ipPerluUpdate.selected"
        )

    v-row.mt-n3
      v-col(cols="12" lg="6")
        p(
          class="pl-4"
          style="font-size:14px"
        ) Apakah perubahan mengurangi barang stok?
      v-col(cols="6" lg="2")
        v-select(
          class="selectInput" 
          :items='checkOptions' 
          label="Pilih" 
          clearable 
          v-model="dataSubmitPerubahan.ipMengurangiStok.selected"
          @change="handleChangeSelect(dataSubmitPerubahan.ipMengurangiStok)"
        ) 
      v-col(cols="6" lg="3" class="mt-n6")
        v-text-field(
          label="Tuliskan" 
          v-model="dataSubmitPerubahan.ipMengurangiStok.description" 
          :disabled="!dataSubmitPerubahan.ipMengurangiStok.selected"
        )

    v-row.mt-n3
      v-col(cols="12" lg="6")
        p(
          class="pl-4"
          style="font-size:14px"
        ) Apakah perubahan memerlukan stok barang atau suku cadang baru?
      v-col(cols="6" lg="2")
        v-select(
          class="selectInput" 
          :items='checkOptions' 
          label="Pilih" 
          clearable 
          v-model="dataSubmitPerubahan.ipStokBaru.selected"
          @change="handleChangeSelect(dataSubmitPerubahan.ipStokBaru)"
        ) 
      v-col(cols="6" lg="3" class="mt-n6")
        v-text-field(
          label="Tuliskan" 
          v-model="dataSubmitPerubahan.ipStokBaru.description" 
          :disabled="!dataSubmitPerubahan.ipStokBaru.selected"
        )

    v-row.mt-n3
      v-col(cols="12" lg="6")
        p(
          class="pl-4"
          style="font-size:14px"
        ) Apakah perubahan menggunakan bahan kimia baru?
      v-col(cols="6" lg="2")
        v-select(
          class="selectInput" 
          :items='checkOptions' 
          label="Pilih" 
          clearable 
          v-model="dataSubmitPerubahan.ipBahanKimia.selected"
          @change="handleChangeSelect(dataSubmitPerubahan.ipBahanKimia)"
        ) 
      v-col(cols="6" lg="3" class="mt-n6")
        v-text-field(
          label="Tuliskan" 
          v-model="dataSubmitPerubahan.ipBahanKimia.description" 
          :disabled="!dataSubmitPerubahan.ipBahanKimia.selected"
        )

    v-row.mt-n3
      v-col(cols="12" lg="6")
        p(
          class="pl-4"
          style="font-size:14px"
        ) Apakah perubahan memerlukan persetujuan dari pabrikan?
      v-col(cols="6" lg="2")
        v-select(
          class="selectInput" 
          :items='checkOptions' 
          label="Pilih" 
          clearable 
          v-model="dataSubmitPerubahan.ipPersetujuanPabrik.selected"
          @change="handleChangeSelect(dataSubmitPerubahan.ipPersetujuanPabrik)"
        ) 
      v-col(cols="6" lg="3" class="mt-n6")
        v-text-field(
          label="Tuliskan" 
          v-model="dataSubmitPerubahan.ipPersetujuanPabrik.description" :disabled="!dataSubmitPerubahan.ipPersetujuanPabrik.selected"
        )

    v-row.mt-n3.mb-5
      v-col(cols="12" lg="6")
        p(
          class="pl-4"
          style="font-size:14px"
        ) Apakah perubahan berdampak pada pihak lain atau dokumen pendukung?
      v-col(cols="6" lg="2")
        v-select(
          class="selectInput" 
          :items='checkOptions' 
          label="Pilih" 
          clearable 
          v-model="dataSubmitPerubahan.ipBerdampakLain.selected"
          @change="handleChangeSelect(dataSubmitPerubahan.ipBerdampakLain)"
        ) 
      v-col(cols="6" lg="3" class="mt-n6")
        v-text-field(
          label="Tuliskan" 
          v-model="dataSubmitPerubahan.ipBerdampakLain.description" 
          :disabled="!dataSubmitPerubahan.ipBerdampakLain.selected"
        )    
    
    v-btn(
      class="mr-3" 
      dark color='blue-grey' 
      @click="backStep(4);scrollTop();"
    ) BACK

    v-btn(
      text 
      class="mr-3" 
      @click="backHome()"
    ) Cancel

    v-btn(
      color="primary" 
      @click="submit(1); scrollTop();" 
      class="mt-3 mt-lg-0"
    ) Save As Draft

    v-btn(
      color="#4CAF50" 
      style="color: white;" 
      class="ml-lg-3 mt-3 mt-lg-0" 
      @click="submit(2)" 
      :disabled="!isPageComplete"
    ) Submit Request
      
</template>

<script>
import { mapState } from "vuex";
import PemegangModal from "../PemegangModal.vue";
import axios from "axios";
export default {
  name: "DaftarPeriksa",
  components: {
    PemegangModal
  },
  props: {
    e1: Number,
    dataSubmitPerubahan: Object,
    edit: { type: Boolean, default: false }
  },
  data() {
    return {
    checkOptions: ["YA", "TIDAK"],
    klasifikasiOptions: [
        'Jenis Peralatan',
        'Lokasi Aktivasi',
        'Nomor Peralatan',
        'Organisasi',
        'Prosedur',
        'Perangkat Lunak',
        'Proses',
        'Rencana Tambang',
        'Bahan Berbahaya',
        'Tata Letak',
        'Desain & Konstruksi',
        'Perubahan Jalan'
    ],
    };
  },
  mounted() {},
  computed: {
    ...mapState(["API_URL", "locations", "dataUsers"]),
    isPageComplete() {
      if ( this.dataSubmitPerubahan.ipTingkatRisikoSetelahPerubahan.tingkatRisiko > 4) {
        return (
          this.checkOption(this.dataSubmitPerubahan.ipPerluPerubahan)
          && this.checkOption(this.dataSubmitPerubahan.ipMempengaruhiGaransi)
          && this.checkOption(this.dataSubmitPerubahan.ipMempengaruhiSpek)
          && this.checkOption(this.dataSubmitPerubahan.ipPerluUpdate)
          && this.checkOption(this.dataSubmitPerubahan.ipMengurangiStok)
          && this.checkOption(this.dataSubmitPerubahan.ipStokBaru)
          && this.checkOption(this.dataSubmitPerubahan.ipBahanKimia)
          && this.checkOption(this.dataSubmitPerubahan.ipPersetujuanPabrik)
          && this.checkOption(this.dataSubmitPerubahan.ipBerdampakLain)
        )
      } else {
        return (
          this.checkOptionTrue(this.dataSubmitPerubahan.ipPerluPerubahan)
          && this.checkOptionTrue(this.dataSubmitPerubahan.ipMempengaruhiGaransi)
          && this.checkOptionTrue(this.dataSubmitPerubahan.ipMempengaruhiSpek)
          && this.checkOptionTrue(this.dataSubmitPerubahan.ipPerluUpdate)
          && this.checkOptionTrue(this.dataSubmitPerubahan.ipMengurangiStok)
          && this.checkOptionTrue(this.dataSubmitPerubahan.ipStokBaru)
          && this.checkOptionTrue(this.dataSubmitPerubahan.ipBahanKimia)
          && this.checkOptionTrue(this.dataSubmitPerubahan.ipPersetujuanPabrik)
          && this.checkOptionTrue(this.dataSubmitPerubahan.ipBerdampakLain)
        )
      }
    }
  },
  methods: {
    submit(val){
      let URL_API = this.edit ? `${this.API_URL}/v1/requests/perubahan/edit` : `${this.API_URL}/v1/requests/perubahan/submit`
      const formData = {...this.dataSubmitPerubahan,ipStatus :val }

      if ( formData.ipTingkatRisikoSetelahPerubahan.tingkatRisiko <= 4 && formData.ipTindakanPengendalian.length > 0 ) {
        formData.ipTindakanPengendalian = []
      }

      const config = {
        method: "post",
        url: URL_API,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        data: formData,
      };
      axios(config).then((res) => {
        this.$store.commit("temporaryData", res);
        this.$router.push("/my-permit");
      }).catch(() => {
        this.$store.state.loader = false;

        //TODO: need to adjust the wording error
        this.$snackbar.showMessage({ message: 'Silahkan isi data dengan benar', color: 'red' })
      });
    },
    backStep(val){
     this.$emit("continueBtn", val);
    },
    backHome(){
      this.$router.push("/my-permit");
    },
    scrollTop(){
      window.scrollTo(0,0);
    },
    docName(name){
        return this.$setFilename(name);
      },
    deleteDocPendukung(name){
      let id = this.uploadId.toString();      
      this.$store
        .dispatch("deleteFile", {
            uploadId: id,
            folderName: name,
        })
        .then(() => {
            this.docUsulan = null;
        })
        .catch(() => {
            this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    checkOption(item) {
      if ( item.selected == "YA" && item.description !== "" ) {
        return true
      } else if ( item.selected == "TIDAK" ) {
        return true
      }
    },
    checkOptionTrue(item) {
      if ( item.selected == "YA" && item.description == "" ) {
        return false
      }

      return true
    },
    handleChangeSelect(item) {
      if ( !item.selected ) {
        item.selected = ''
        item.description = ''
      }
    }
  },
  watch: {
    docPendukung(params){
      if(params && params.size < 10000000){
         let formData = new FormData();
        formData.append('uploadId', this.uploadId );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
      }
    },
  },
};
</script>

<style></style>
